/**
 * Collections Enhanced Experience
 * Premium interactions and animations for the collections page
 */

document.addEventListener('DOMContentLoaded', function () {
  // Initialize smooth scroll behavior
  document.documentElement.style.scrollBehavior = 'smooth';

  // Animate product cards on scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '50px'
  };

  const productCards = document.querySelectorAll('.product-card');
  const cardObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }, index * 100);
        cardObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  productCards.forEach(card => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(30px)';
    card.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
    cardObserver.observe(card);
  });

  // Enhanced filter interactions
  const filterPills = document.querySelectorAll('.ag-filter-pill');
  filterPills.forEach(pill => {
    pill.addEventListener('click', function (e) {
      // Add ripple effect
      const ripple = document.createElement('span');
      ripple.style.position = 'absolute';
      ripple.style.width = '20px';
      ripple.style.height = '20px';
      ripple.style.background = 'rgba(246, 185, 0, 0.5)';
      ripple.style.borderRadius = '50%';
      ripple.style.transform = 'translate(-50%, -50%)';
      ripple.style.pointerEvents = 'none';
      ripple.style.animation = 'ripple 0.6s ease-out';

      const rect = this.getBoundingClientRect();
      ripple.style.left = (e.clientX - rect.left) + 'px';
      ripple.style.top = (e.clientY - rect.top) + 'px';

      this.style.position = 'relative';
      this.style.overflow = 'hidden';
      this.appendChild(ripple);

      setTimeout(() => ripple.remove(), 600);
    });
  });

  // Subtle, viewport-aware parallax for the collection hero media.
  const collectionHero = document.querySelector('.template-collection .ag-collection-hero, body.template-collection .ag-collection-hero');
  const collectionHeroMedia = document.querySelector('.template-collection .ag-collection-hero__bg, body.template-collection .ag-collection-hero__bg');
  if (collectionHero && collectionHeroMedia) {
    const updateCollectionHeroParallax = () => {
      const rect = collectionHero.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

      if (rect.bottom <= 0 || rect.top >= viewportHeight) {
        collectionHeroMedia.style.transform = 'translateY(0px) scale(1.08)';
        return;
      }

      const heroCenter = rect.top + (rect.height / 2);
      const viewportCenter = viewportHeight / 2;
      const offset = (heroCenter - viewportCenter) * -0.12;

      collectionHeroMedia.style.transform = `translateY(${offset.toFixed(2)}px) scale(1.08)`;
    };

    updateCollectionHeroParallax();
    window.addEventListener('scroll', updateCollectionHeroParallax, { passive: true });
    window.addEventListener('resize', updateCollectionHeroParallax);
  }

  // Add hover sound effect simulation (visual feedback)
  const addSoundWave = (element) => {
    const wave = document.createElement('div');
    wave.style.position = 'absolute';
    wave.style.inset = '0';
    wave.style.background = 'transparent';
    wave.style.opacity = '0';
    wave.style.transition = 'opacity 0.3s ease';
    wave.style.pointerEvents = 'none';

    element.style.position = 'relative';
    element.appendChild(wave);

    element.addEventListener('mouseenter', () => {
      wave.style.opacity = '1';
    });

    element.addEventListener('mouseleave', () => {
      wave.style.opacity = '0';
    });
  };

  // Apply sound wave to all interactive elements
  document.querySelectorAll('.product-card, .tag, .pagination-button').forEach(addSoundWave);

  // Enhanced pagination with page numbers
  const paginationButtons = document.querySelectorAll('.pagination-button');
  paginationButtons.forEach((button, index) => {
    button.addEventListener('click', function () {
      // Remove active class from all buttons
      paginationButtons.forEach(btn => btn.classList.remove('active'));
      // Add active class to clicked button
      this.classList.add('active');

      // Animate page transition
      document.querySelector('.collection-grid').style.opacity = '0.5';
      setTimeout(() => {
        document.querySelector('.collection-grid').style.opacity = '1';
      }, 300);
    });
  });

  // Keyboard navigation support
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      const activeButton = document.querySelector('.pagination-button.active');
      if (activeButton) {
        const buttons = Array.from(paginationButtons);
        const currentIndex = buttons.indexOf(activeButton);

        if (e.key === 'ArrowLeft' && currentIndex > 0) {
          buttons[currentIndex - 1].click();
        } else if (e.key === 'ArrowRight' && currentIndex < buttons.length - 1) {
          buttons[currentIndex + 1].click();
        }
      }
    }
  });

  const enforceFourLineDescriptions = () => {
    document.querySelectorAll('.template-collection .ag-fc-card__desc, body.template-collection .ag-fc-card__desc').forEach((desc) => {
      desc.style.display = '-webkit-box';
      desc.style.webkitBoxOrient = 'vertical';
      desc.style.webkitLineClamp = '3';
      desc.style.overflow = 'hidden';
      desc.style.setProperty('text-align', 'left', 'important');
      desc.style.maxHeight = 'calc(1.5em * 3)';
    });
  };

  enforceFourLineDescriptions();

  const collectionHeroVideo = document.querySelector('.template-collection .ag-collection-hero__img, body.template-collection .ag-collection-hero__img');
  if (collectionHeroVideo) {
    collectionHeroVideo.style.setProperty('filter', 'brightness(0.5)', 'important');
  }

  const collectionHeroTextWrapper = document.querySelector('.template-collection .ag-collection-hero__text-wrapper, body.template-collection .ag-collection-hero__text-wrapper');
  if (collectionHeroTextWrapper) {
    collectionHeroTextWrapper.style.removeProperty('background');
    collectionHeroTextWrapper.style.removeProperty('backdrop-filter');
    collectionHeroTextWrapper.style.removeProperty('-webkit-backdrop-filter');
    collectionHeroTextWrapper.style.removeProperty('border');
    collectionHeroTextWrapper.style.removeProperty('box-shadow');
    collectionHeroTextWrapper.style.removeProperty('padding');
    collectionHeroTextWrapper.style.removeProperty('border-radius');
  }

  const collectionHeroTitle = document.querySelector('.template-collection .ag-collection-hero__title, body.template-collection .ag-collection-hero__title');
  if (collectionHeroTitle) {
    collectionHeroTitle.style.setProperty('text-shadow', '0 2px 10px rgba(0, 0, 0, 0.46), 0 8px 24px rgba(0, 0, 0, 0.42), 0 0 42px rgba(255, 255, 255, 0.18), 0 0 0 1px rgba(255, 255, 255, 0.34)', 'important');
  }

  const collectionHeroSubheading = document.querySelector('.template-collection .ag-collection-hero__subheading, body.template-collection .ag-collection-hero__subheading');
  if (collectionHeroSubheading) {
    collectionHeroSubheading.style.setProperty('text-shadow', '0 2px 8px rgba(0, 0, 0, 0.52), 0 8px 22px rgba(0, 0, 0, 0.34), 0 0 28px rgba(255, 255, 255, 0.14)', 'important');
    collectionHeroSubheading.style.setProperty('color', '#ffffff', 'important');
  }

  const collectionHeroEyebrow = document.querySelector('.template-collection .ag-collection-hero__eyebrow, body.template-collection .ag-collection-hero__eyebrow');
  if (collectionHeroEyebrow) {
    collectionHeroEyebrow.style.setProperty('text-shadow', '0 2px 12px rgba(0, 0, 0, 0.68), 0 0 28px rgba(246, 185, 0, 0.24)', 'important');
    collectionHeroEyebrow.style.setProperty('color', '#ffffff', 'important');
  }

  // Hydrate the main collection grid if Shopify renders the shell but no items.
  const collectionGrid = document.querySelector('.ag-product-grid-container .ag-product-grid');
  const collectionGridContainer = document.querySelector('.ag-product-grid-container');
  if (collectionGrid && collectionGrid.children.length === 0 && collectionGridContainer && !collectionGridContainer.querySelector('.ag-empty-state')) {
    const currentPath = window.location.pathname.replace(/\/$/, '');
    const fallbackPath = '/collections/all';

    const stripHtml = (html) => {
      const div = document.createElement('div');
      div.innerHTML = html || '';
      return (div.textContent || div.innerText || '').trim();
    };

    const truncate = (text, maxLength) => {
      if (!text || text.length <= maxLength) return text;
      return `${text.slice(0, maxLength - 1).trim()}...`;
    };

    const formatMoney = (price) => {
      const value = Number(price || 0);
      return new Intl.NumberFormat('en-PH', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(value);
    };

    const deriveWeight = (product) => {
      const firstVariant = product.variants && product.variants[0];
      if (!firstVariant) return '';

      const title = (firstVariant.title || '').trim();
      const titleLower = title.toLowerCase();
      if (title && titleLower !== 'default' && titleLower !== 'default title') {
        return title;
      }

      const grams = Number(firstVariant.grams || 0);
      if (grams >= 1000) {
        const kg = grams / 1000;
        return Number.isInteger(kg) ? `${kg}kg` : `${kg.toFixed(1)}kg`;
      }
      if (grams > 0) {
        return `${grams}g`;
      }
      return '';
    };

    const getCardLabel = (product) => {
      const productType = ((product.product_type || product.type || '')).trim();
      if (productType) return productType;

      const tags = product.tags || [];
      const originTag = tags.find(tag => String(tag).toLowerCase().startsWith('origin:'));
      return originTag ? originTag.split(':').slice(1).join(':').trim() : 'Agriko';
    };

    const CARD_IMAGE_WIDTHS = [360, 540, 720];

    const escapeHtml = (value) => String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    const buildShopifyImageUrl = (src, width) => {
      if (!src) return '';

      const [baseUrl, queryString] = String(src).split('?');
      const match = baseUrl.match(/^(.*?)(\.(?:avif|gif|jpe?g|png|webp|bmp|tiff?))$/i);
      if (!match) return src;

      const resizedBase = match[1].replace(/_\d+x(?:\d+)?$/i, '');
      const resizedUrl = `${resizedBase}_${width}x${match[2]}`;
      return queryString ? `${resizedUrl}?${queryString}` : resizedUrl;
    };

    const buildShopifyImageSrcset = (src) => {
      if (!src) return '';

      return CARD_IMAGE_WIDTHS
        .map((width) => `${buildShopifyImageUrl(src, width)} ${width}w`)
        .join(', ');
    };

    const getImageDimensions = (image) => {
      const width = Number(image && image.width);
      const height = Number(image && image.height);

      if (width > 0 && height > 0) {
        return { width, height };
      }

      return { width: 720, height: 720 };
    };

    const renderCard = (product, index) => {
      const image = product.images && product.images[0];
      const imageSrc = image ? buildShopifyImageUrl(image.src, 540) : '';
      const imageSrcset = image ? buildShopifyImageSrcset(image.src) : '';
      const imageDimensions = getImageDimensions(image);
      const imageLoading = index < 4 ? 'eager' : 'lazy';
      const weight = deriveWeight(product);
      const origin = getCardLabel(product);
      const cardSummaries = (() => { try { const el = document.getElementById('ag-card-summaries'); return el ? JSON.parse(el.textContent) : {}; } catch(e) { return {}; } })();
      const description = cardSummaries[product.id] || truncate(stripHtml(product.body_html), 220);
      const firstVariant = product.variants && product.variants[0];
      const price = formatMoney(firstVariant ? firstVariant.price : 0);
      const escapedTitle = escapeHtml(product.title);
      const productUrl = `/products/${encodeURIComponent(product.handle)}`;

      return `
        <div class="ag-product-grid__item" data-product-tags="${(product.tags || []).map(t => t.toLowerCase()).join('|')}">
          <article class="ag-fc-card" data-reveal data-lot="${(index % 6) + 1}" data-product-tags="${(product.tags || []).map(t => t.toLowerCase()).join(',')}">
            <div class="ag-fc-card__media">
              ${imageSrc ? `<img src="${imageSrc}" srcset="${imageSrcset}" sizes="(min-width: 1200px) 25vw, (min-width: 768px) 33vw, 50vw" alt="${escapedTitle}" width="${imageDimensions.width}" height="${imageDimensions.height}" loading="${imageLoading}" decoding="async">` : '<div class="ag-card__placeholder"><span>Agriko</span></div>'}
              ${weight ? `<span class="ag-fc-card__weight-badge">${weight}</span>` : ''}
            </div>
            <div class="ag-fc-card__content">
              <div class="ag-fc-card__body">
                <span class="ag-fc-card__origin">${origin}</span>
                <h3 class="ag-fc-card__title">
                  <a href="${productUrl}" class="ag-fc-card__title-link">${escapedTitle}</a>
                </h3>
                <div class="ag-fc-card__rating" aria-label="5 out of 5 stars">
                  <span class="ag-stars" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                  </span>
                </div>
                ${description ? `<p class="ag-fc-card__desc">${description}</p>` : ''}
              </div>
              <div class="ag-fc-card__footer">
                <div class="ag-fc-card__footer-top">
                  <span class="ag-fc-card__price">${price}</span>
                </div>
                <a href="${productUrl}" class="ag-button ag-button--primary ag-button--small ag-fc-card__btn">
                  <span>View Product</span>
                  <svg class="ag-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14"></path>
                    <path d="M12 5v14"></path>
                  </svg>
                </a>
              </div>
            </div>
          </article>
        </div>
      `;
    };

    const fetchProducts = async (url) => {
      const response = await fetch(`${url.replace(/\/$/, '')}/products.json?limit=24`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }
      return response.json();
    };

    (async () => {
      try {
        let data;
        try {
          data = await fetchProducts(currentPath);
        } catch (error) {
          data = await fetchProducts(fallbackPath);
        }

        const products = Array.isArray(data.products) ? data.products : [];
        if (!products.length) return;

        collectionGrid.innerHTML = products.map((product, index) => renderCard(product, index)).join('');
        enforceFourLineDescriptions();

        const pagination = collectionGridContainer.querySelector('.ag-collection-pagination');
        if (pagination && products.length < 24) {
          pagination.remove();
        }
      } catch (error) {
        console.warn('Agriko collection grid hydration failed.', error);
      }
    })();
  }

  // Normalize the collection card label from Shopify product type on live cards.
  if (collectionGrid && collectionGrid.children.length > 0) {
    const rawPath = window.location.pathname.replace(/\/$/, '');
    const currentPath = rawPath.replace(/^(\/collections\/[^/]+)(\/[^/]+)?$/, '$1');
    const fallbackPath = '/collections/all';

    const fetchProducts = async (url) => {
      const response = await fetch(`${url.replace(/\/$/, '')}/products.json?limit=24`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }
      return response.json();
    };

    const getCardLabel = (product) => {
      const productType = ((product.product_type || product.type || '')).trim();
      if (productType) return productType;

      const tags = product.tags || [];
      const originTag = tags.find(tag => String(tag).toLowerCase().startsWith('origin:'));
      return originTag ? originTag.split(':').slice(1).join(':').trim() : 'Agriko';
    };

    (async () => {
      try {
        let data;
        try {
          data = await fetchProducts(currentPath);
        } catch (error) {
          data = await fetchProducts(fallbackPath);
        }

        const products = Array.isArray(data.products) ? data.products : [];
        if (!products.length) return;

        const labelByHandle = new Map(products.map((product) => [product.handle, getCardLabel(product)]));

        collectionGrid.querySelectorAll('.ag-fc-card').forEach((card) => {
          const link = card.querySelector('.ag-fc-card__title-link[href*="/products/"]');
          const label = card.querySelector('.ag-fc-card__origin');
          if (!link || !label) return;

          const href = link.getAttribute('href') || '';
          const match = href.match(/\/products\/([^/?#]+)/);
          if (!match) return;

          const nextLabel = labelByHandle.get(match[1]);
          if (nextLabel) {
            label.textContent = nextLabel;
          }
        });
      } catch (error) {
        console.warn('Agriko collection card labels could not be normalized.', error);
      }
    })();
  }

  // Ensure collection filter pills always filter client-side on shop-all and collection pages.
  const initShopAllClientFiltering = (attempt = 0) => {
    const maxAttempts = 12;
    const state = window.__agrikoShopAllFilterController || {
      initialized: false,
      routePath: '',
      initializing: false
    };
    window.__agrikoShopAllFilterController = state;

    const getRoutePath = () => String(window.location.pathname || '').replace(/\/$/, '').toLowerCase();
    const normalizeTag = (value) => String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[\u2018\u2019`]/g, '')
      .replace(/[\-_]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    const decodeHtml = (value) => String(value || '')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');

    const routePath = getRoutePath();
    const isCollectionAllRoute = /\/collections\/(?:all|shop-all)(?:\/|$)/.test(routePath);
    const collectionRouteMatch = routePath.match(/^(\/collections\/(?:all|shop-all))(?:\/|$)/);
    const filterBasePath = collectionRouteMatch ? collectionRouteMatch[1] : window.location.pathname.replace(/\/$/, '');
    state.routePath = routePath;
    state.initializing = false;
    state.attempts = attempt;

    if (!isCollectionAllRoute) {
      state.initialized = false;
      if (state._filterRoot && state._filterClickHandler) {
        state._filterRoot.removeEventListener('click', state._filterClickHandler);
      }
      if (state._popstateHandler) {
        window.removeEventListener('popstate', state._popstateHandler);
      }
      state._filterRoot = null;
      state._filterClickHandler = null;
      state._popstateHandler = null;
      return;
    }

    const sectionRoot = document.getElementById('all-products');
    const gridContainer = sectionRoot ? sectionRoot.querySelector('.ag-product-grid-container') : null;
    const grid = gridContainer ? (gridContainer.querySelector('.ag-product-grid--collection') || gridContainer.querySelector('.ag-product-grid')) : null;

    if (!sectionRoot || !gridContainer || !grid) {
      if (attempt < maxAttempts) {
        setTimeout(() => initShopAllClientFiltering(attempt + 1), 250);
      }
      return;
    }

    const requiredFilters = [
      { tag: 'daily drinks', label: 'Daily Drinks' },
      { tag: 'herbal tea', label: 'Herbal Tea' },
      { tag: 'whole grain rice', label: 'Whole-Grain Rice' },
      { tag: 'family breakfast', label: 'Family Breakfast' },
      { tag: 'pantry essentials', label: 'Pantry Essentials' }
    ];
    const legacyTagSet = new Set([
      'better sleep', 'gut health', 'immunity boost', 'natural energy', 'stress relief',
      'daily wellness', 'whole grain nutrition', 'family nutrition'
    ]);

    const filterList = sectionRoot.querySelector('.ag-filter-list');
    if (!filterList) {
      if (attempt < maxAttempts) {
        setTimeout(() => initShopAllClientFiltering(attempt + 1), 250);
      }
      return;
    }

    const itemElements = () => Array.from(grid.querySelectorAll('.ag-product-grid__item'));

    const allExistingButtons = Array.from(filterList.querySelectorAll('.ag-filter-pill[data-filter-tag]'));
    const existingByTag = new Map();
    allExistingButtons.forEach((button) => {
      const key = normalizeTag(button.getAttribute('data-filter-tag'));
      if (!key) {
        return;
      }
      if (!existingByTag.has(key)) {
        existingByTag.set(key, button);
      }
    });

    // Remove static anchor pills whose tags requiredFilters will re-create as buttons
    const requiredTagSet = new Set(requiredFilters.map((f) => f.tag));
    Array.from(filterList.querySelectorAll('.ag-filter-pill:not([data-filter-tag])')).forEach((anchor) => {
      const staticTag = normalizeTag(anchor.textContent.trim());
      if (requiredTagSet.has(staticTag) || legacyTagSet.has(staticTag)) {
        filterList.removeChild(anchor);
      }
    });

    const createFilterPill = (tag, label) => {
      const newButton = document.createElement('button');
      newButton.type = 'button';
      newButton.className = 'ag-filter-pill';
      newButton.setAttribute('data-filter-tag', tag);
      const tagPath = tag.trim().toLowerCase().replace(/\s+/g, '-');
      newButton.setAttribute('data-filter-url', tagPath ? `${filterBasePath}/${tagPath}` : filterBasePath);
      newButton.setAttribute('aria-label', `Filter by ${label}`);
      newButton.setAttribute('aria-pressed', 'false');
      newButton.setAttribute('aria-disabled', 'false');
      newButton.setAttribute('tabindex', '0');
      newButton.textContent = label;
      return newButton;
    };

    const ensureButtonNode = (source, label, tag) => {
      if (!source) {
        return createFilterPill(tag, label);
      }

      if (source.nodeName === 'BUTTON') {
        normalizeAndUpgrade(source, label, tag);
        source.setAttribute('tabindex', '0');
        return source;
      }

      const replacement = createFilterPill(tag, label);
      if (source.parentNode) {
        source.parentNode.replaceChild(replacement, source);
      }
      return replacement;
    };

    const normalizeAndUpgrade = (button, label, tag) => {
      if (!button) {
        return null;
      }
      button.type = 'button';
      button.classList.add('ag-filter-pill');
      button.setAttribute('data-filter-tag', tag);
      const tagPath = tag.trim().toLowerCase().replace(/\s+/g, '-');
      button.setAttribute('data-filter-url', tagPath ? `${filterBasePath}/${tagPath}` : filterBasePath);
      button.setAttribute('aria-label', `Filter by ${label}`);
      button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
      button.setAttribute('tabindex', button.classList.contains('ag-filter-pill--static') ? '-1' : '0');
      button.setAttribute('aria-disabled', 'false');
      button.textContent = label;
      return button;
    };

    const allButton = filterList.querySelector('[data-filter-tag=""]');

    // Rebuild filter pill order and labels so legacy templates remain aligned.
    const canonicalButtons = [];
    if (allButton) {
      canonicalButtons.push(allButton);
    }

    requiredFilters.forEach((filter) => {
      const normalizedTag = filter.tag;
      const existing = allExistingButtons.find((node) => normalizeTag(node.getAttribute('data-filter-tag')) === normalizedTag);
      const safeButton = ensureButtonNode(existing || existingByTag.get(normalizedTag), filter.label, normalizedTag);
      if (!safeButton.parentNode) {
        filterList.appendChild(safeButton);
      } else if (safeButton.parentNode === filterList) {
        filterList.removeChild(safeButton);
      }
      canonicalButtons.push(safeButton);
    });

    allExistingButtons.forEach((button) => {
      const normalizedTag = normalizeTag(button.getAttribute('data-filter-tag'));
      if (!normalizedTag || requiredFilters.some((filter) => filter.tag === normalizedTag) || normalizedTag === '') {
        return;
      }
      if (legacyTagSet.has(normalizedTag)) {
        if (button.parentNode === filterList) {
          filterList.removeChild(button);
        }
        return;
      }
      if (button.parentNode === filterList) {
        filterList.removeChild(button);
      }
      canonicalButtons.push(button);
    });

    canonicalButtons.forEach((button) => {
      if (button && button.nodeName === 'BUTTON' && button.parentNode) {
        filterList.appendChild(button);
      }
    });

    const filterButtons = Array.from(filterList.querySelectorAll('.ag-filter-list [data-filter-tag].ag-filter-pill'))
      .filter((node) => !node.classList.contains('ag-filter-pill--static'));

    if (!filterButtons.length || !itemElements().length) {
      if (attempt < maxAttempts) {
        setTimeout(() => initShopAllClientFiltering(attempt + 1), 250);
      }
      return;
    }

    const getItemTags = (item) => {
      const raw = item && item.getAttribute ? decodeHtml(item.getAttribute('data-product-tags') || '') : '';
      return String(raw || '')
        .split('|')
        .map(normalizeTag)
        .filter(Boolean);
    };

    const tagMatches = (itemTags, targetTag) => {
      const normalizedTag = normalizeTag(targetTag);
      if (!normalizedTag) {
        return true;
      }

      return itemTags.indexOf(normalizedTag) !== -1;
    };

    const routeTag = () => {
      const currentPath = getRoutePath();
      const match = currentPath.match(/\/collections\/(?:all|shop-all)\/([^/]+)/);
      return normalizeTag(match ? decodeURIComponent(match[1] || '') : '');
    };

    const syncButtonAvailability = () => {
      const hasAnyMatch = (tag) => itemElements().some((item) => tagMatches(getItemTags(item), tag));
      filterButtons.forEach((button) => {
        const buttonTag = normalizeTag(button.getAttribute('data-filter-tag'));
        const hasMatch = hasAnyMatch(buttonTag);
        const isEmpty = !hasMatch && !!buttonTag;
        button.hidden = isEmpty;
        button.classList.remove('is-inactive', 'is-disabled');
        button.removeAttribute('aria-disabled');
      });
    };

    let filterStatus = sectionRoot.querySelector('[data-product-filter-status]');
    if (!filterStatus) {
      filterStatus = document.createElement('p');
      filterStatus.className = 'ag-sr-only';
      filterStatus.setAttribute('data-product-filter-status', '');
      filterStatus.setAttribute('role', 'status');
      filterStatus.setAttribute('aria-live', 'polite');
      filterStatus.setAttribute('aria-atomic', 'true');
      gridContainer.before(filterStatus);
    }

    const applyClientFilter = (tag, announceResults = false) => {
      const normalizedTag = normalizeTag(tag);
      let visibleCount = 0;

      itemElements().forEach((item) => {
        const tags = getItemTags(item);
        const matches = tagMatches(tags, normalizedTag);
        item.hidden = !matches;
        item.classList.toggle('is-filtered-out', !matches);
        item.setAttribute('aria-hidden', matches ? 'false' : 'true');
        if (matches) {
          visibleCount += 1;
        }
      });

      state.activeTag = normalizedTag;
      state.lastVisibleCount = visibleCount;
      state.totalItems = itemElements().length;
      state.lastUpdateAt = Date.now();

      let emptyState = gridContainer.querySelector('.ag-empty-state--client-filter');
      if (!visibleCount) {
        if (!emptyState) {
          emptyState = document.createElement('div');
          emptyState.className = 'ag-empty-state ag-empty-state--client-filter';
          emptyState.innerHTML = '<div class="ag-empty-state__icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8.5l-1.5 12.5a2 2 0 01-2 2H6.5a2 2 0 01-2-2L3 8.5M3 8.5h18M3 8.5l1.17-3.5A2 2 0 016.08 3h11.84a2 2 0 011.91 2L21 8.5"/><path d="M9 11.5v6M15 11.5v6"/></svg></div><h3 class="ag-empty-state__title">No Products Found</h3><p class="ag-empty-state__copy">No products matched that wellness focus. Try another filter.</p>';
          gridContainer.appendChild(emptyState);
        }
      } else if (emptyState) {
        emptyState.remove();
      }
      if (announceResults) {
        const focus = normalizedTag ? ` for ${normalizedTag}` : '';
        filterStatus.textContent = visibleCount
          ? `${visibleCount} product${visibleCount === 1 ? '' : 's'} shown${focus}.`
          : `No products found${focus}. Try another filter.`;
      }
    };

    const setActiveButton = (button) => {
      filterButtons.forEach((node) => {
        const isActive = node === button;
        node.classList.toggle('is-active', isActive);
        node.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      // Sync the "All" anchor which has no data-filter-tag and is excluded from filterButtons
      const allAnchor = filterList.querySelector('.ag-filter-pill:not([data-filter-tag])');
      if (allAnchor) {
        const isAllActive = !button || !button.getAttribute('data-filter-tag');
        allAnchor.classList.toggle('is-active', isAllActive);
      }
    };

    const getButtonByTag = (targetTag) => filterButtons.find((button) => {
      return normalizeTag(button.getAttribute('data-filter-tag')) === targetTag;
    });

    const resolveActiveButton = () => {
      const tag = routeTag();
      if (tag) {
        const activeFromRoute = getButtonByTag(tag);
        if (activeFromRoute) {
          return activeFromRoute;
        }
      }

      const allButton = getButtonByTag('');
      if (allButton) {
        return allButton;
      }

      return filterButtons[0];
    };

    const updateFromButton = (button, shouldUpdateUrl) => {
      if (!button) {
        return;
      }
      const selectedTag = button.getAttribute('data-filter-tag') || '';
      setActiveButton(button);
      applyClientFilter(selectedTag, shouldUpdateUrl);

      if (shouldUpdateUrl && button.dataset && button.dataset.filterUrl) {
        window.history.replaceState({}, '', button.dataset.filterUrl);
      }
    };

    const onFilterPillClick = (event) => {
      const target = event.target && event.target.closest
        ? event.target.closest('.ag-filter-list [data-filter-tag].ag-filter-pill')
        : null;
      if (!target || target.classList.contains('ag-filter-pill--static') || !sectionRoot.contains(target)) {
        return;
      }
      event.preventDefault();
      updateFromButton(target, true);
    };

    if (state._filterRoot !== sectionRoot) {
      if (state._filterRoot && state._filterClickHandler) {
        state._filterRoot.removeEventListener('click', state._filterClickHandler);
      }
      state._filterRoot = sectionRoot;
      state._filterClickHandler = onFilterPillClick;
      sectionRoot.addEventListener('click', onFilterPillClick);
    }

    filterButtons.forEach((button) => {
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');
      button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
      if (!button.dataset.__agrikoKeydownBound) {
        button.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') {
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          button.click();
        });
        button.dataset.__agrikoKeydownBound = '1';
      }
    });

    if (state._observer && state._observedGrid !== grid) {
      state._observer.disconnect();
      state._observer = null;
      state._observedGrid = null;
    }
    if (!state._observer) {
      const observer = new MutationObserver(() => {
        syncButtonAvailability();
      });
      observer.observe(grid, { childList: true, subtree: true });
      state._observer = observer;
      state._observedGrid = grid;
    }

    if (!state._popstateHandler) {
      state._popstateHandler = () => {
        const activeFromRoute = resolveActiveButton();
        updateFromButton(activeFromRoute, false);
      };
      window.addEventListener('popstate', state._popstateHandler);
    }

    state.initializedAt = new Date().toISOString();
    state.lastUpdateAt = Date.now();
    state.initialized = true;
    state.initializing = false;

    syncButtonAvailability();
    grid.classList.add('ag-product-grid--agriko-reinitialized');

    const urlTag = routeTag();
    if (urlTag) {
      const activeButton = resolveActiveButton();
      updateFromButton(activeButton, false);
    } else {
      applyClientFilter('');
      filterButtons.forEach(btn => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });
      const allAnchor = filterList.querySelector('.ag-filter-pill:not([data-filter-tag]), .ag-filter-pill[data-filter-tag=""]');
      if (allAnchor) allAnchor.classList.add('is-active');
    }

    // Activate scroll-reveal on filter panel elements immediately after
    // initialization — the IntersectionObserver in theme.js only fires when
    // the element enters the viewport, but the filter panel starts off-screen,
    // leaving pills invisible (opacity:0) until the user scrolls. Activating
    // here ensures pills are visible as soon as JS hydration completes.
    const filterRevealEls = sectionRoot.querySelectorAll(
      '.ag-filter-panel__header[data-reveal], .ag-filter-panel__controls[data-reveal]'
    );
    filterRevealEls.forEach((el) => {
      el.setAttribute('data-reveal', 'active');
      el.classList.add('is-revealed');
    });
  };

  initShopAllClientFiltering();
});

// Add CSS keyframes dynamically
const style = document.createElement('style');
style.textContent = `
  @keyframes ripple {
    to {
      transform: translate(-50%, -50%) scale(4);
      opacity: 0;
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  .ag-home-hero__media {
    transition: transform 0.1s ease-out;
  }

  .product-card__overlay {
    background: linear-gradient(to bottom,
      transparent 0%,
      rgba(14, 62, 41, 0.8) 50%,
      rgba(14, 62, 41, 0.95) 100%);
  }
`;
document.head.appendChild(style);
